module.exports = __webpack_public_path__ + "img/price-white.644cab13.svg";